import React, { Component } from "react";
import { Box } from "reflexbox";
import { CommandBar } from "office-ui-fabric-react/lib/CommandBar";
import { SearchBox } from "office-ui-fabric-react/lib/SearchBox";

import ToggleForm from "../../common/Buttons/_ToggleForm";
import _ from "lodash";

import ToggleShipmentAttachmentDialog from "../../common/Buttons/_ToggleShipmentAttachmentDialog";
import ShipmentDeleteButton from "../../common/Buttons/_ShipmentDeleteButton";
import ShipmentToArchive from "../../common/Buttons/_ShipmentToArchive";
import ShipmentExelExport from "../Reports/_ShipmentExelExport";

class ShipmentTableCommandBar extends Component {
  _onRenderItem = item => {
    return <div key={item.key}>{item.component} </div>;
  };

  render() {
    return (
      <Box w={0.5}>
        <CommandBar
          isSearchBoxVisible={false}
          items={[
            {
              onRender: this._onRenderItem,
              component: (
                <Box style={{ marginTop: "5px" }}>
                  <SearchBox
                    className="searchBox"
                    placeholder="Search"
                    onChange={this.props.handleSearch}
                  />
                </Box>
              ),
              key: "item1"
            },
            {
              onRender: this._onRenderItem,
              component: <ToggleForm form="shipment" addOrEdit="add" />,
              key: "item2"
            },
            {
              onRender: this._onRenderItem,
              component: (
                <ToggleForm
                  form="shipment"
                  addOrEdit="edit"
                />
              ),
              key: "item3"
            },
            {
              onRender: this._onRenderItem,
              component: <ToggleShipmentAttachmentDialog />,
              key: "item4"
            },
            {
              onRender: this._onRenderItem,
              component: (
                <ShipmentDeleteButton items={this.props.selectedItems} />
              ),
              key: "item5"
            },
            {
              onRender: this._onRenderItem,
              component: <ShipmentToArchive items={this.props.selectedItems} />,
              key: "item6"
            },
            {
              onRender: this._onRenderItem,
              component: (
                <ShipmentExelExport items={this.props.selectedItems} />
              ),
              key: "item7"
            }
          ]}
        />
      </Box>
    );
  }
}

export default ShipmentTableCommandBar;



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentTableCommandBar.js